import { useQuery } from '@tanstack/react-query';
import { getMyOwnTractors, myOwnTractorsApiUrl } from '../../../../api/user/queries/getMyOwnTractors';
import { useCheckUserLoggedIn } from '../../../user/useCheckUserLoggedIn';
import { IMyOwnTractor } from '../../../../interfaces/OwnTractor.interfaces';

export interface IUseGetMyOwnTractorsParams {
  searchParam?: {
    machineApprovalStatus: string;
    isPokeEnabled: boolean;
  };
}

export const useGetMyOwnTractors = ({ searchParam }: IUseGetMyOwnTractorsParams) => {
  const { isUserLoggedIn } = useCheckUserLoggedIn();

  return useQuery<IMyOwnTractor[]>(
    [
      myOwnTractorsApiUrl,
      `machineApprovalStatus=${searchParam?.machineApprovalStatus}`,
      `isPokeEnabled=${searchParam?.isPokeEnabled}`,
    ],
    () => getMyOwnTractors({ searchParam }),
    { enabled: isUserLoggedIn },
  );
};
